export const ZaveIcon = ({ size = 24 }) => {
  // Original SVG dimensions
  const originalSize = 48;
  // Calculate dynamic values based on size
  const scale = size / originalSize;
  const strokeWidth = 1 * scale;
  const borderRadius = originalSize / 2;
  
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox={`0 0 ${originalSize} ${originalSize}`} 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect 
        width={originalSize} 
        height={originalSize} 
        rx={borderRadius} 
        fill="#1D1D1D"
      />
      <rect 
        x={strokeWidth / 2} 
        y={strokeWidth / 2} 
        width={originalSize - strokeWidth} 
        height={originalSize - strokeWidth} 
        rx={borderRadius - strokeWidth / 2} 
        stroke="white" 
        strokeOpacity="0.3"
        strokeWidth={strokeWidth}
        fill="none"
      />
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M17.6385 14.0001C23.359 14.0875 26.9143 14.0729 26.9143 14.0729C31.03 14.1202 32.8058 16.3036 33.297 18.396C33.7774 20.4702 33.6536 22.9774 29.4761 25.0699C29.4761 25.0699 25.9172 26.853 21.1611 29.1966C20.5424 29.5022 19.8 29.1528 19.6436 28.4797V28.476C19.5271 27.9884 19.7709 27.4862 20.2222 27.2679C26.0663 24.444 28.5809 23.1268 28.5809 23.1268C31.3575 21.7439 31.5467 20.2846 31.2228 18.8837C30.899 17.4826 29.2505 16.2418 26.9725 16.2126C26.9725 16.2126 24.8364 16.2163 17.6166 16.1435C17.1218 16.1362 16.6924 15.7942 16.5795 15.3138C16.4231 14.637 16.9435 13.9892 17.6385 14.0001ZM29.8475 33.9999C24.127 33.9126 20.5718 33.9272 20.5718 33.9272C16.4561 33.8798 14.6802 31.6965 14.1889 29.604C13.7086 27.5297 13.8323 25.0226 18.0099 22.9302C18.0099 22.9302 21.5687 21.147 26.3249 18.8036C26.9435 18.4979 27.686 18.8472 27.8423 19.5204V19.524C27.9589 20.0117 27.7151 20.5139 27.2638 20.7322C21.4196 23.556 18.9051 24.8734 18.9051 24.8734C16.1286 26.2562 15.9393 27.7154 16.2631 29.1165C16.5871 30.5175 18.2355 31.7583 20.5135 31.7873C20.5135 31.7873 22.6496 31.7838 29.8693 31.8566C30.3642 31.8639 30.7936 32.2059 30.9064 32.6862C31.0629 33.3632 30.5425 34.0108 29.8475 33.9999Z" 
        fill="#F4F4F4"
      />
    </svg>
  )
}